import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { useLang } from "@/lib/navigation";

export const LegalPage = ({ namespace, testId, children }) => {
  const { t } = useTranslation();
  const lang = useLang();
  const sections = t(`${namespace}.sections`, { returnObjects: true }) || [];

  return (
    <div className="bg-background" data-testid={testId}>
      <div className="strata-band h-1.5 w-full" aria-hidden="true" />
      <div className="container-page py-14 sm:py-16">
        <Button
          asChild
          variant="ghost"
          className="-ml-2 mb-6 h-9 rounded-lg px-3 text-xs text-[hsl(var(--ink-2))]"
          data-testid={`${testId}-back-link`}
        >
          <Link to={`/${lang}`}>
            <ArrowLeft className="mr-1.5 h-3.5 w-3.5" />
            {t("nav.home")}
          </Link>
        </Button>

        <div className="max-w-3xl">
          <p className="font-data text-[11px] uppercase tracking-[0.16em] text-[hsl(var(--ink-3))]">
            {t(`${namespace}.updated`)}
          </p>
          <h1 className="mt-3 text-3xl font-semibold tracking-tight text-foreground sm:text-[40px]">
            {t(`${namespace}.title`)}
          </h1>
          <p className="mt-5 border-l-2 border-[hsl(var(--terracotta))] pl-4 text-sm leading-relaxed text-[hsl(var(--ink-2))] sm:text-base">
            {t(`${namespace}.intro`)}
          </p>

          <Separator className="my-10" />

          <div className="space-y-9">
            {sections.map((section, index) => (
              <section key={section.h} data-testid={`${testId}-section-${index}`}>
                <h2 className="text-lg font-semibold tracking-tight text-foreground sm:text-xl">
                  {section.h}
                </h2>
                <div className="mt-3 space-y-3">
                  {(section.p || []).map((paragraph) => (
                    <p
                      key={paragraph.slice(0, 40)}
                      className="text-sm leading-relaxed text-muted-foreground sm:text-[15px]"
                    >
                      {paragraph}
                    </p>
                  ))}
                </div>
              </section>
            ))}
          </div>

          {children}
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
